<template>
  <div class="page" v-wechat-title="$route.meta.title">

    <!--搜索-->
    <div class="station-search border-box box">
      <div class="station-search-con box">
        <form class="station-search-bar border-box flex" action="." v-on:submit.prevent="search" @click="searchListShow=1">
          <img class="station-search-icon" src="../../assets/icon-search.png" alt="" @click.stop='search'>
          <input type="search" class="station-search-input" placeholder="搜索景区、解说员名" value="" v-model='inputValue'/>
          <img class="station-input-close none" src="../../assets/input-close.png" alt="" v-show="inputValue"
               @click.stop="inputValue=''">
        </form>
        <div class="search-history-cancel flex" v-if="searchListShow==1" @click="searchListShow=0">取消</div>
      </div>
      <div class="search-history-list border-box" v-if="searchListShow==1">
        <p class="search-history-tit" v-if="history.length > 0">搜索历史 <img src="../../assets/icon_01.png" alt="" @click="delHistory"></p>
        <p class="search-history-my clearfix">
          <span v-for="(item,index) in history" @click="searchHistory(item)">{{item}}</span>
        </p>
      </div>
    </div>


    <!--轮播图-->
    <div class="banner p024 border-box">
      <Swiper :banners="banners" :type="'home'"></Swiper>
    </div>

    <!-- 热门城市 -->
    <div class="main-hot-city border-box" v-if="!siteid">
      <img class="main_hot_title" src="../../assets/main_hot_title.png"/>
      <div class="hot-citys clearfix">
        <p class="hot-citys-name hide" v-for="(item,index) in hotcity" @click="citySelected(item.city,item.code)">
          {{item.city}}</p>
      </div>

      <router-link class="main-address border-box hide" to="/city">
        <img class="main_address_bg" src="../../assets/main_address_bg.png"/>
        <div class="main_address_box clearfix">
          <img class="main_address_icon" src="../../assets/location-icon1.png"/>
          <span class="hide border-box" v-show="loadEnd">{{cityInfo.city || '全国'}}</span>
        </div>
      </router-link>
    </div>

    <!--热门景区-->
    <div class="conference-list p024">
      <div class="list-tit"><span></span>热门景区</div>
      <div class="conference-item-parent"  @click="toViewDetail(item.id)" v-for="(item,index) in root">
      <!--<div class="conference-item-parent"  @click="showPhoto(item.logo,item.id)" v-for="(item,index) in root">-->
        <div class='conference-item border-box'>
          <div class="conference-item-img loadBg" :id="'div'+item.id">
            <!--<img class="img" v-lazy="item.logo" alt="" v-if="currQJ!=item.id">-->
          </div>
          <span class="conference-item-hover-text">讲解点{{item.spotnum}}个</span>
          <div class="conference-item-info clearfix">
            <div class="label-box fl">
              <div class="fl conference-item-title hide" :style="latlng.lat==''?'max-width:100%;':''">{{item.name}}</div>
              <div class="fl left-info" v-if="item.juli!='...'&&latlng.lat!=''">
                <img class="conference-item-address-icon" src="../../assets/station-icon-adress.png" alt="">
                <span class="conference-item-rote">{{item.juli|initDistance}}</span>
              </div>
            </div>
            <div class="fr lineH60 right-info">
              <div v-if="item.listen>0" class='conference-item-info-label'>
                <img src="../../assets/station-icon-listen.png" alt="">
                <span class="icon-time">{{item.listen|initNumber}}</span>
              </div>
              <div v-if="item.buys>0" class='conference-item-info-label'>
                <img src="../../assets/station-icon-buy.png" alt="">
                <span class="icon-time">{{item.buys|initNumber}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <p class="load-tip" v-show="root.length<=0&&loadEnd">暂无数据</p>
    </div>
    <router-link class="conference-list-title p024" v-show="total>=20"
                 :to="{path:'/view-list',query: {siteid:siteid, TimeStamp: TimeStamp, inputValue: inputValue, appKey: appKeyA}}">
      更多景区
    </router-link>

    <!--分隔行-->
    <p class="split-line h15"></p>

    <!--语音列表-->
    <img class="main_hot_title main_hot_voice" src="../../assets/main_hot_voice.png"/>
    <div class="list border-box">
      <template v-for="(item,index) in bagList">
        <div class="list-box box" @click="goVideoPlay(index)">
          <!--左侧头像部分-->
          <div class="block list-img">
            <!--解说员头像-->
            <img class="icon-tx" v-lazy="item.guideheadimg2?item.guideheadimg2:item.guideheadimg" alt=""
                 @click.stop="goGuideInfo(item.id)">
            <!--头像底部语音播放 -->
            <router-link class="listen-btn-num" :to="{path:'/video-play',query: {id:item.id,spotid:item.spotid,shopid:item.shopid, TimeStamp: TimeStamp, appKey: appKeyA}}" v-if="item.buy==12||item.price==0||item.isuser">
              <img src="../../assets/icon-listen.png" alt="">
              <span>收听</span>
            </router-link>
            <div class="listen-btn-num" @click.stop="listenTurlClick(index)" v-else>
              <img
                :src="item.isplay==1?require('../../assets/icon_listen02.gif'):require('../../assets/icon-listen.png')"
                alt="">
              <span>{{item.isplay==1?item.resTime+"'":"试听"}}</span>
            </div>
          </div>
          <!--右侧语音内容部分-->
          <div class="block flex list-info">
            <!--语音名称-->
            <div class="list-name guide-name hide">{{item.guidename2?item.guidename2:item.guidename}}
              <span v-if="item.guidetag">{{item.guidetag}}</span>
            </div>
            <div class="list-group hide">
              <span class="fl hide">{{item.name}}</span>
              <span v-if="item.label" class="label-color label-type">{{item.label}}</span>
            </div>
            <!--标签-->
            <div class="mt6 clearfix">
              <div v-if="item.listen>0" class="label-color">
                <img src="../../assets/icon-label-listen.png" alt="">
                <span>{{item.listen|initNumber}}人收听</span>
              </div>
              <div v-if="item.buynum>0" class="label-color">
                <img src="../../assets/icon-label-buy.png" alt="">
                <span>{{item.buynum|initNumber}}人购买</span>
              </div>
              <div v-if="item.buynum<=0&&item.dsnum>0&&item.noReward!=1" class="label-color">
                <img src="../../assets/icon-label-buy.png" alt="">
                <span>{{item.dsnum|initNumber}}人打赏</span>
              </div>
            </div>
            <div class="sees-num-block clearfix">
              <div class="label-color">
                <img src="../../assets/icon-label-sees.png" alt="">
                <span>包含{{item.sees}}个讲解点</span>
              </div>
            </div>
            <!--价格-->
            <div class="price-text-box clearfix">
              <div class="price-text">
                <div v-if="item.price!=0">{{item.price}}元<span class="sees-num-inline">(包含{{item.sees}}个讲解点)</span>
                </div>
                <div v-else>打赏<span class="sees-num-inline">(包含{{item.sees}}个讲解点)</span></div>
              </div>
            </div>
            <!--右侧购买收听按钮-->
            <button class="btn buy-btn buy-btn1" @click.stop="goVideoPlay(index)">详情</button>
            <button v-if="(item.buy==12)||(item.isuser)" class="btn buy-btn buy-btn2" @click.stop="goVideoPlay(index)">收听</button>
            <button v-else-if="item.price==0" class="btn buy-btn buy-btn2" @click.stop="goVideoPlay(index,'rewardShow')">打赏</button>
            <button v-else class="btn buy-btn buy-btn2" @click.stop="buyVideo(index)">购买/激活</button>
          </div>
        </div>
      </template>
      <p class="load-tip" v-show="bagList.length<=0&&loadEnd">暂无数据</p>
    </div>
    <router-link class="conference-list-title p024" v-show="bagcount>=20" :to="{path:'/voice-list',query: {siteid:siteid, TimeStamp: TimeStamp, inputValue: inputValue, appKey: appKeyA}}">更多解说</router-link>


    <!--试听结束弹窗新版-->
    <AlertListenEnd :bag="bag" :couponid="couponid" :extral="extral" @close="closeEnd" v-if="Object.keys(bag).length>0"></AlertListenEnd>

    <audio src="" id="Audio" style="overflow: hidden" src="http://wangchuang-1252493175.coscd.myqcloud.com/jpjs/upload/voice/20181126/iosvoicetest.mp3"></audio>

    <!--底部导航栏-->
    <Foot :siteid="siteid"></Foot>


  </div>


</template>

<script>

  import PhotoSphereViewer from 'photo-sphere-viewer'
  import 'photo-sphere-viewer/dist/photo-sphere-viewer.css'
  import Swiper from '../../components/Swiper'
  import Foot from '../../components/Foot'
  import {getHome,getHotCity,getHomeBag,uploadUserBrowse} from "@/service/getData";
  import {wxGetPosition,wxShareme, getCityInfo, listenEndOrder, listenTurl, creatOrder, pushOrder, getHotCity1} from '@/utils/wechat'
  import {setStore, getStore, removeStore} from '@/config/mUtils'
  import AlertListenEnd from '../../components/AlertListenEnd'

  import wxConfirm from '@/wechat-messagebox/Confirm'
  import D from '@/wc-messagebox'
  import Vue from 'vue'
  Vue.use(D)

  export default {
    data(){
      return {
        sregion: '', //省站点id:430000
        cityName: '',
        siteid: '', //站点id
        userInfo: {}, //用户信息
        latlng: {lat: '', lng: ''}, //经纬度信息
        cityInfo: {}, //城市信息
        banners: [],
        hotcity: [], //热门城市
        root: [],//景区列表
        bagList: [],//语音列表
        total: 0, //景区总数
        bagcount: 0, //语音总数
        inputValue: '',//搜索关键词
        loadEnd: false, //数据加载结束则赋值为true

        Audio: '', //音频dom
        videoTimer: null, //语音播放计时器
        currIndex: -1, //当前播放音频数组下标
        index1: 0, //当前播放音频数组下标(用来记录currIndex，传值给下订单方法)
        bag: {}, //当前试听的专辑
        extral: {}, //存放下单需要的值
        couponid: '', //优惠券id

        TimeStamp: new Date().getTime(),  //获取当前时间
        appKey: '',
        appKeyA: '',

        searchListShow: 0, //搜索历史
        history: [], //历史记录

        displaypanoramadata: false,
        currQJ: -1,
      }
    },
    computed: {},
    created(){
      let self = this;
      this.$loading.show('数据加载中');
      this.appKey = this.$route.query.appKey || "";
      this.appKeyA = this.appKey
      if (this.appKey) {
        this.appKey = encodeURIComponent(this.appKey)
        setStore("appKey", {"appKey": this.appKey});
        this.sendUserBrowse();
      } else {
        setStore("appKey", {"appKey": ""});
      }

      this.siteid = this.$route.query.siteid || getStore("siteid") || "";
      if (this.siteid != "" && this.siteid != null && this.siteid != undefined) {
        setStore("siteid", this.siteid);
      }

      this.sregion = this.$route.query.sregion || getStore("sregion") || "";
      if (this.sregion != "" && this.sregion != null && this.sregion != undefined) {
        setStore("sregion", this.sregion);
      }

      this.userInfo = getStore("userInfo");

      let cityInfo = getStore("cityInfo");
      if (cityInfo == null || cityInfo.citycode == null || cityInfo.citycode == "") {
        getCityInfo(function (res) {
          self.latlng = res;
          self.cityInfo = getStore("cityInfo");
          self.initData();
        });
      } else {
        this.cityInfo = getStore("cityInfo");
        wxGetPosition(function (res) {
          self.latlng = {lat: res.latitude, lng: res.longitude};
          self.initData();
        });
      }
      window.addEventListener("scroll", function () {})

      let history = getStore("history",1) || "";
      if (history) {
        this.history = history.history
      }
    },
    beforeDestroy(){
      window.removeEventListener("scroll", function () {});
      if (this.videoTimer) {
        clearInterval(this.videoTimer);
        this.currIndex = -1;
        this.bagList[this.index1].isplay = 0;
        this.bag = {};
      }
    },
    methods: {
      //初始化：获取景区数据
      async initData(){

        this.loadEnd = false;

        //获取热门城市
        var self = this;
        getHotCity1(this.sregion,function(resCity){
          if (resCity.errcode == "00000") {
            self.hotcity = resCity.data.hotcity;
          } else {
            self.$toast(resCity.errmsg)
            self.$router.push({
              path: `/400?${'appKey=' + self.appKey}`
            });
          }
        });

        //获取景区数据
        let resView = await getHome({
          TimeStamp: this.TimeStamp,
          siteid: this.siteid,
          code: this.cityInfo.citycode || '1',
          lat: this.latlng.lat || '',
          lng: this.latlng.lng || '',
          page: 1,
          rows: 20,
          type: 0, //0:热门 1:距离排序
          onlyshop: 1, //1:需要景区数据
          onlybag: 1, //1:需要导游数据
          name: this.inputValue, //搜索关键词
          cid: '', //导游筛选
          openid: this.userInfo.openid,
          sregion: this.sregion
        });
        if (resView.errcode == "00000") {
          if(resView.data.root.length > 0){
            this.$loading.hide();
          }

          this.root = resView.data.root;
          this.banners = resView.data.imgurls;
          this.total = resView.data.total;

          let title = '金牌解说 | 让景区有声 让文旅共创';

          if(this.sregion){
            this.$route.meta.title = resView.data.title || '金牌解说';
            title = '金牌解说 | '+ resView.data.title || '让景区有声 让文旅共创';

            if(resView.data.city){ //传的参数code不属于当前省站点，则返回
              this.cityInfo.citycode = resView.data.citycode;
              this.cityInfo.city = resView.data.city;
              setStore("cityInfo",this.cityInfo);
            }
          }else {
            this.$route.meta.title = '金牌解说'
          }

          let desc = '历史会说话！金牌解说与您共享历史故事~';
          let link = '/?siteid='+ this.siteid +'&sregion='+ this.sregion +'&appKey=' + this.appKey;
          wxShareme(title, desc, "", link);

        } else {
          this.$loading.hide();
        }

        //获取专辑数据
        let resBag = await getHomeBag({
          TimeStamp: this.TimeStamp,
          siteid: this.siteid,
          code: this.cityInfo.citycode || '1',
          page: 1,
          rows: 20,
          type: 0, //0:热门 1:距离排序
          onlybag: 1, //1:需要导游数据
          name: this.inputValue, //搜索关键词
          cid: '', //导游筛选
          openid: this.userInfo.openid,
          sregion: this.sregion
        });
        if (resBag.errcode == "00000") {
          for (var i = 0; i < resBag.data.baglist.length; i++) {
            resBag.data.baglist[i].isplay = 0;
            resBag.data.baglist[i].toaTime = '';
            resBag.data.baglist[i].resTime = '';
          }
          this.bagList = resBag.data.baglist;
          this.bagcount = resBag.data.bagcount;

          this.$loading.hide();
          this.loadEnd = true;
        }


      },

      //上传浏览数据
      async sendUserBrowse(){
        this.userInfo = getStore("userInfo");
        let res = await
        uploadUserBrowse({
          openid: this.userInfo.openid,
          appKey: this.appKey,
        });
      },

      //点击试听，调用试听公用方法
      listenTurlClick(ind){
        listenTurl(this, ind, this.bagList)
      },

      //点击购买，调用下订单公用方法
      buyVideo(ind){
        let self = this;

        setStore("source", {"source": "index"});
        setStore("couponid", {"couponid": ""});
        self.$router.push({
          path: `/pay?${'pid='+self.bagList[ind].id+'&cid='+self.couponid+'&shopid='+self.bagList[ind].shopid+'&appKey=' + self.appKey}`
        });
      },

      //关闭试听弹窗，购买成功修改音频状态
      closeEnd(msg){
        this.bag = msg.bag;
        if (msg.isbuy) {
          this.bagList[this.index1].buy = 12;
        }
      },

      //跳转到专辑详情页
      goVideoPlay(ind,rewardShow){
        if(rewardShow){
          this.$router.push({
            path: `/video-play?${'id='+this.bagList[ind].id+'&spotid='+this.bagList[ind].spotid+'&shopid='+this.bagList[ind].shopid+'&TimeStamp='+this.TimeStamp+'&appKey='+this.appKey+'&rewardShow=1'}`
          });
        }else {
          this.$router.push({
            path: `/video-play?${'id='+this.bagList[ind].id+'&spotid='+this.bagList[ind].spotid+'&shopid='+this.bagList[ind].shopid+'&TimeStamp='+this.TimeStamp+'&appKey='+this.appKey}`
          });
        }
      },

      //跳转到导游详情页
      goGuideInfo(id){
        this.$router.push({
          path: `/guide-info?${'id=' + id + '&TimeStamp=' + this.TimeStamp+'&appKey=' + this.appKey}`
        });
      },

      //选择城市
      citySelected(city, citycode){
        let cityInfo = {citycode: citycode, city: city, address: ""};
        setStore("cityInfo", cityInfo);
        this.cityInfo = cityInfo;
        this.inputValue = "";

        this.$loading.show('数据加载中');

        this.root = [];
        this.bagList = [];
        this.banners = [];
        this.initData();
      },

      //删除历史记录
      delHistory(){
        let self = this;

        this.$confirm({
          title: '提示',
          content: '确认删除全部历史记录？',
          component: wxConfirm
        }).then(function(res){
          if(res == 'success') {
            self.history = [];
            setStore("history", {"history":[] },1);
          }
        }).catch(function(res){
          if(res == 'success') {
            self.history = [];
            setStore("history", {"history":[] },1);
          }
        })
      },

      //发送搜索信息inputVaule
      search(){
        this.inputValue = this.inputValue.replace(/(^\s*)|(\s*$)/g, "");
        if(this.inputValue == ''){
          this.$toast('请输入搜索关键词')
        }else {
          if(this.history.indexOf(this.inputValue) < 0){
            this.history.push(this.inputValue);
          }
          setStore("history", {"history":this.history },1);
          this.searchHistory(this.inputValue);
        }
      },

      //搜索某一条
      searchHistory(inputValue){
        this.$router.push({
          path: `/home-search?${'inputValue=' + inputValue + '&TimeStamp=' + this.TimeStamp+ '&appKey=' + this.appKey}`
        });
      },

      toViewDetail(id){
        this.$router.push({
          path: `/view-detail?${'shopid='+ id +'&siteid='+ this.siteid + '&sregion=' + this.sregion + '&TimeStamp='+ this.TimeStamp+'&appKey='+(this.appKey)}`
        });
      },

      showPhoto(imgurl,id){
//        var imgurl = require('../../assets/qj.jpg');
        if(this.displaypanoramadata == true){
          this.displaypanoramadata = false;
          this.panoramadata.destroy()
          this.currQJ = -1;
        }else {
          this.displaypanoramadata = true;
          this.currQJ = id;
          this.panoramadata = PhotoSphereViewer({
            container: 'div'+id,
            panorama: imgurl,
            autoload: true, //自动播放
            time_anim: 3000, //默认2000
            anim_speed: '0.4rpm', //默认2rpm
            size: {
//              width: '760',
//              height: '760'
            },
            navbar: false  //不显示下面的导航栏
          });
        }
      },

      showPhoto1(imgurl,obj){
        var imgurl = require('../../assets/qj.jpg');
        PhotoSphereViewer({
          container: obj,
          panorama: imgurl,
          autoload: true, //自动播放
//          time_anim: 3000, //默认2000
//          anim_speed: '0.4rpm', //默认2rpm
          navbar: false  //不显示下面的导航栏
        });
      },

    },
    watch:  {
      bag(newVal, oldVal){
        if (Object.keys(newVal).length) {
          listenEndOrder(this, this.index1, this.bagList);
        }
      },
      'cityInfo.citycode'(newVal, oldval){
        if (newVal != oldval) {

        }
      },
      root(){
        var self = this;
        this.$nextTick(function(){
          for(var i=0; i<self.root.length; i++){
            self.showPhoto1("","div"+self.root[i].id);
          }
        })
      }
    },
    components: {
      Swiper,
      Foot,
      AlertListenEnd,
    },

    //格式化数据
    filters: {
      initNumber: function (num) {
        if (num > 10000) {
          num = (num / 10000).toFixed(2) + '万'
        } else if (num > 1000) {
          num = (num / 1000).toFixed(2) + '千'
        }
        return num;
      }
    ,
      initDistance: function (num) {
        if (num > 1000) {
          num = (num / 1000).toFixed(2) + 'KM'
        }
        return num;
      }
    }
  }

</script>

<style scoped>
  @import "../../style/view.css";
  @import "../../style/voice.css";

  .page { padding-bottom: 2.4rem; background-color: #fff; }

  /*搜索*/
  .station-search { position: fixed; top: 0; left: 0; width: 100%; height: 1.08rem; padding: .2rem .24rem; background: #fff; z-index: 99; }
  .station-search-con { position: relative; z-index: 99; }
  .station-search-bar { display: block; height: .68rem; line-height: .68rem; margin-top: 0; border-radius: .06rem; }
  .station-search-input { width: 80%; height: .68rem; line-height: .68rem; }
  .station-search-icon { position: absolute; right: 0; top: 50%; padding: .2rem .2rem .2rem 0; -webkit-transform: translateY(-50%); transform: translateY(-50%); z-index: 999; }
  .station-input-close { position: absolute; top: 50%; right: .50rem; width: .19rem; height: .19rem; padding: .20rem; -webkit-transform: translateY(-50%); transform: translateY(-50%); z-index: 999; }

  /*搜索记录*/
  .search-history-cancel{ width: 1.8rem; padding-left: .24rem;  height: .68rem; line-height: .68rem; font-size: .28rem; color: #2671fb; text-align: center; }
  .search-history-list{ position: fixed; top: 0; left: 0; width: 100%; height: 100%; padding: 1.48rem .3rem .3rem 0; background: #fff; z-index: 98; }
  .search-history-tit{ position: relative; padding-left:.4rem; height: .4rem; line-height: .4rem; color: #343434; }
  .search-history-tit img{ position: absolute; top: .05rem; right: 0; width:.28rem; height: .3rem; }
  .search-history-my span{ float: left; margin-left: .5rem; margin-top: .3rem; font-size: .28rem; color: #000; }

  /* banner */
  .banner { position: relative; margin-top: 1.08rem; height: 3rem; border-radius: .07rem; }

  /* 热门城市 */
  .main-hot-city { padding: .45rem .24rem 0; }
  .main_hot_title { display: block; width: 7.01rem; height: .36rem; padding-bottom: .32rem; margin: 0 auto; }
  .hot-citys .hot-citys-name { float: left; width: 1.30rem; height: .60rem; margin-right: .13rem; margin-bottom: .15rem; font: normal .28rem/.60rem "Microsoft YaHei"; color: #999; text-align: center; background: #efefef; }
  .hot-citys .hot-citys-name:nth-of-type(5n) { margin-right: 0; }
  .main-address { position: relative; display: block; width: 4.00rem; height: .76rem; padding: 0 .20rem; margin: .30rem auto 0; text-align: center; font: .32rem/.76rem "Microsoft YaHei"; color: #fff; border-radius: .30rem; }
  .main_address_bg { position: absolute; top: 0; left: 0; width: 100%; height: 100%; border-radius: .30rem; }
  .main_address_box { display: inline-block;width: 100%; height: .76rem; color: #fff; }
  .main_address_icon { float: left; position: relative; width: .34rem; height: .39rem; margin-top: .21rem; z-index: 1; }
  .main-address span { float: left; position: relative; display: inline-block; width: 100%; padding-left: .10rem; max-width: 3.20rem; z-index: 1; }

  /* 景区列表 */
  .conference-list-title { display: block; margin-top: 0; height: .80rem; line-height: .80rem; font-size: .28rem; color: #666; text-align: center; border-top: .01rem solid #ebebeb; }
  .conference-item-hover-text { left: .15rem; }
  .conference-list { margin-top: .13rem; }

  /*专辑列表*/
  .main_hot_voice { margin-top: .35rem; }
  .list { margin-top: .08rem; padding: 0 .24rem .20rem; }

  .list-tit{ padding: .2rem 0; height: .36rem; line-height: .36rem; font-size: .34rem; font-weight: bold; color: #333; }
  .list-tit span{ float: left; margin-right: .12rem; width: .07rem; height: .36rem; background-color: #faaf39; }


</style>



// WEBPACK FOOTER //
// src/page/home/home1.vue